import { render, staticRenderFns } from "./imgEditor.vue?vue&type=template&id=96187040&scoped=true&lang=html&"
import script from "./imgEditor.vue?vue&type=script&lang=js&"
export * from "./imgEditor.vue?vue&type=script&lang=js&"
import style0 from "./imgEditor.vue?vue&type=style&index=0&id=96187040&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96187040",
  null
  
)

component.options.__file = "imgEditor.vue"
export default component.exports